(function($, undefined) {
	"use strict";
	
	function init() {
		$('.wizard_step4 .wizard__questions').on('submit', onFormSubmit);
	}

	function onFormSubmit(e) {
		let form = $(e.currentTarget);
		let contactsList = $('#current-location-contacts-list');
		let contactsListItems = $('.location-form-editable-list-item:not(.template)', contactsList);

		e.preventDefault();

		let contactsArray = [];
		contactsListItems.each((i, el) => {
			contactsArray.push(JSON.parse($(el).attr('data-json')));
		});

		$('[name="field11"]', form).val(JSON.stringify(contactsArray));

		form.get(0).submit();
	}
	
	$(init);
	
})(jQuery);